import { Breadcrumb, Button, Layout, Space } from "antd";
import React, { useState } from "react";
import WithSidebar from "../../templates/withSidebar";

// common components
import Alert from "../../components/common/alert";
import ConfirmModal from "../../components/modal/confirmModal";
import FailModal from "../../components/modal/failModal";
import SuccessModal from "../../components/modal/successModal";
import useAuth from "../../lib/hooks/useAuth";

const { Content } = Layout;

const UI = () => {
  const { auth } = useAuth();
  const [alertType, setAlertType] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("Content of the modal");

  const [failModal, setFailModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);

  const handleOk = () => {
    setModalText("The modal will be closed after two seconds");
    setConfirmLoading(true);
    setTimeout(() => {
      setOpenModal(false);
      setConfirmLoading(false);
    }, 2000);
  };

  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpenModal(false);
  };

  console.log("auth :: ", auth);

  return (
    <WithSidebar>
      <Content
        style={{
          margin: "0 16px",
        }}
      >
        <Breadcrumb
          style={{
            margin: "16px 0",
          }}
        >
          <Breadcrumb.Item>UI</Breadcrumb.Item>
          <Breadcrumb.Item>Guideline</Breadcrumb.Item>
        </Breadcrumb>
        <div
          style={{
            padding: 24,
            minHeight: 360,
          }}
        >
          <div>
            <Space wrap>
              <Button onClick={() => setAlertType("info")}>toast info</Button>
              <Button onClick={() => setAlertType("warning")}>
                toast warning
              </Button>
              <Button onClick={() => setAlertType("error")}>toast error</Button>
              <Button onClick={() => setAlertType("success")}>
                toast success
              </Button>
              <Button onClick={() => setAlertType("default")}>
                toast default
              </Button>
            </Space>
          </div>
          <div style={{ marginTop: 15 }}>
            <Space wrap>
              <Button onClick={() => setOpenModal(true)}>confirm modal</Button>
              <Button onClick={() => setFailModal(true)}>fail modal</Button>
              <Button onClick={() => setSuccessModal(true)}>
                success modal
              </Button>
            </Space>
          </div>
        </div>

        <Alert type={alertType} />

        <ConfirmModal
          title={"ยืนยันการลบข้อมูล"}
          open={openModal}
          modalText={modalText}
          onOk={handleOk}
          confirmLoading={confirmLoading}
          onCancel={handleCancel}
          actionType={"delete"}
        />

        <FailModal open={failModal} setOpen={setFailModal} />
        <SuccessModal
          open={successModal}
          setOpen={setSuccessModal}
          subTitle={"ทำรายการสำเร็จ"}
        />
      </Content>
    </WithSidebar>
  );
};

export default UI;
